module.exports = __webpack_public_path__ + "img/guaranteed.593f691c.svg";